function escapeCsv(value) {
    const s = value == null ? "" : String(value);
    if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
}

export function exportTasksToCsv(tasks, filename = "tasks-export.csv") {
    const headers = [
        "Title",
        "Status",
        "Priority",
        "Due Date",
        "Assign To",
        "Assigned By",
        "Repetition",
        "Notes",
    ];
    const rows = tasks.map((t) => [
        t.title,
        t.status,
        t.priority,
        t.due_date ? new Date(t.due_date).toLocaleDateString("en-GB") : "",
        t.staffuser
            ? `${t.staffuser.firstName || ""} ${t.staffuser.lastName || ""}`.trim()
            : t.assign_to || "",
        t.assigned_by || "",
        t.repetition || "",
        (t.notes || "").replace(/\n/g, " "),
    ]);

    const csv = [headers, ...rows].map((row) => row.map(escapeCsv).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
}
